import React from "react";
import ModalBaseView from "../../../../../../common-deprecated/components/modals/aem/ModalBaseView";
import * as Modal from "../../../../../../common-deprecated/styles/v2/lexus/globals/Modal";
import * as Button from "../../../../../../common-deprecated/styles/v2/lexus/components/Button";
import Icon from "../../../../../../common-deprecated/styles/v2/lexus/globals/Icon";
import { IconWrapper } from "../../../../../../common-deprecated/styles/v2/lexus/globals/IconWrapper";
import { type BuildAndBuyLabelType, BnbLabel, getBnbOptionalLabel } from "../../../utils/labels";
import type { LeaseTermsModalType } from "../../../utils/modalConstants";
import { useBnbSelector } from "../../../redux/store";
import type { ModalViewType } from "../../../../../../common-deprecated/types/CommonTypes";

const labelKeys: BuildAndBuyLabelType[] = [
    "leaseTermsConditionsDescription",
    "leaseTermsConditionsScroll1",
    "leaseTermsConditionsScroll2",
    "leaseTermsConditionsExtra",
];

const monthlyLabelKeys: BuildAndBuyLabelType[] = [
    "leaseTermsConditionsDescriptionMonthly",
    "leaseTermsConditionsScroll1Monthly",
    "leaseTermsConditionsScroll2Monthly",
    "leaseTermsConditionsExtraMonthly",
];

const LeaseTermsModal = (props: ModalViewType<LeaseTermsModalType>): JSX.Element => {
    const { show, close, modalSettings } = props;
    const financeOption = useBnbSelector((state) => state.utils.financeOption);
    const bnbSettings = useBnbSelector((state) => state.bnbSettings);
    const commonSettings = useBnbSelector((state) => state.commonSettings);

    return (
        <ModalBaseView modalIdType={modalSettings.type} onClose={close} show={show} size="md">
            <Modal.Header>
                <Modal.Title>
                    <BnbLabel
                        fallbackLabel="leaseTermsConditionsTitle"
                        label={
                            financeOption === "cash" ? "leaseTermsConditionsTitle" : "leaseTermsConditionsTitleMonthly"
                        }
                    />
                </Modal.Title>
                <Modal.Button type="button" onClick={close}>
                    <IconWrapper>
                        <Icon variant="close" />
                    </IconWrapper>
                </Modal.Button>
            </Modal.Header>
            <Modal.Body>
                {labelKeys.map(
                    (key, index) =>
                        !!getBnbOptionalLabel({ bnbSettings, commonSettings }, key) && (
                            <div key={key}>
                                <BnbLabel
                                    fallbackLabel={key}
                                    label={financeOption === "cash" ? key : monthlyLabelKeys[index]}
                                    useHTML
                                />
                            </div>
                        ),
                )}
            </Modal.Body>
            <Modal.Actions>
                <Button.Primary type="button" onClick={close}>
                    <BnbLabel
                        fallbackLabel="leaseTermsConditionsOk"
                        label={financeOption === "cash" ? "leaseTermsConditionsOk" : "leaseTermsConditionsOkMonthly"}
                    />
                </Button.Primary>
            </Modal.Actions>
        </ModalBaseView>
    );
};

export default LeaseTermsModal;
